import { createAction } from 'redux-actions'
import * as constants from './constants'

export const fetchTargets = createAction(constants.FETCH_TARGETS)
export const fetchTargetsPending = createAction(constants.FETCH_TARGETS_PENDING)
export const fetchTargetsSuccess = createAction(constants.FETCH_TARGETS_SUCCESS)
export const fetchTargetsFailed = createAction(constants.FETCH_TARGETS_FAILED)

export const updateTarget = createAction(constants.UPDATE_TARGET)
export const updateTargetPending = createAction(constants.UPDATE_TARGET_PENDING)
export const updateTargetSuccess = createAction(constants.UPDATE_TARGET_SUCCESS)
export const updateTargetFailed = createAction(constants.UPDATE_TARGET_FAILED)

export const createTarget = createAction(constants.CREATE_TARGET)
export const createTargetPending = createAction(constants.CREATE_TARGET_PENDING)
export const createTargetSuccess = createAction(constants.CREATE_TARGET_SUCCESS)
export const createTargetFailed = createAction(constants.CREATE_TARGET_FAILED)

export const setTarget = createAction(constants.SET_TARGET)

// handlePatchTarget
// handleTargetCreation
// setTarget



// WEBPACK FOOTER //
// ./src/scripts/app/modules/targeting/actions.js